export class AssetAssignmentEditModel {
    constructor() {
        this.id = "";
        this.workPlace = "";
    }
}
export default class AseetAssignmentEdit extends AssetAssignmentEditModel {
    constructor(model) {
        super();
        Object.assign(this, model);
    }
}
